import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({ children, onClick, type = "button", className = "", to }) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event); // Ensure onClick works (for login)
    }
    if (to) {
      navigate(to); // Navigate only if `to` is provided
    }
  };

  return (
    <button
      type={type}
      className={`btn btn-primary px-3 ${className}`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default Button;
